'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getCompanyWithUserCount(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/listwithusercount`
        const result = await axios.get(url, {
          ...costumHeader('Get Company Count', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  saveGlobalConfig(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/company_config/add`
        const result = await axios.post(url, body, costumHeader('Save Global Config', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  saveGlobalConfigMerge(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/company_config/edit_merge`
        const result = await axios.post(url, body, costumHeader('Save Global Config Merge', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editGlobalConfig(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/company/company_config/edit`
        const result = await axios.post(url, body, costumHeader('Edit Global Config', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  
}

export default { actions }